import { useState } from "react";
import { useLocation } from "react-router-dom";

/* The reset/set-password step machine. */
export const STEP_EMAIL = 1;
export const STEP_SENT = 2;
export const STEP_PASSWORD = 3;
export const STEP_DONE = 4;

/* Exported so the positional rule above can be asserted on its own. */
export const initialStep = (search = "") =>
  String(search).slice(1, 6) === "token" ? STEP_PASSWORD : STEP_EMAIL;

export const useResetFlow = () => {
  const { search } = useLocation();
  const [step, setStep] = useState(() => initialStep(search));
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setSuccessStatus] = useState(false);

  /* Transcribed: the page's handleEmailNext takes (email, password) and goes to step 2. */
  const handleEmailNext = (nextEmail, nextPassword) => {
    setEmail(nextEmail);
    setPassword(nextPassword);
    setStep(STEP_SENT);
  };

  const handlePasswordBack = () => setStep(STEP_EMAIL);
  const handleVerifyNext = () => setStep(STEP_PASSWORD);

  const handleNameNext = (nextStatus) => {
    setSuccessStatus(nextStatus);
    setStep(STEP_DONE);
  };

  return {
    step,
    email,
    password,
    status,
    handleEmailNext,
    handlePasswordBack,
    handleVerifyNext,
    handleNameNext,
  };
};

export default useResetFlow;
